import { useState } from 'react'
import { ChromePicker } from 'react-color'
import { TColor } from '../unifiedColorPicker.types'

interface IStandardColorPicker {
  className: string
  activeColor: TColor
  onChange: ({ value }) => void
}

export function StandardColorPicker({
  className,
  activeColor,
  onChange,
}: IStandardColorPicker) {
  const [selectedColor, setSelectedColor] = useState<string>(
    activeColor?.value || ''
  )

  const onColorSelection = ({ hex }) => {
    setSelectedColor(hex)
    onChange({ value: hex })
  }

  return (
    <div className={`hex-color-picker ${className}`}>
      <ChromePicker
        color={selectedColor}
        value={selectedColor}
        disableAlpha={true}
        onChange={onColorSelection}
        className="!w-full min-w-[160px] max-w-[300px]"
      />
    </div>
  )
}
